
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";
import UiButton from "@/components/button/ui-button.vue";
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
import FormDatepicker from "@/components/form/FormDatepicker.vue";
import TimeTrackingDelete from "@/components/icons/TimeTrackingDelete.vue";
import TimeTrackingEdit from "@/components/icons/TimeTrackingEdit.vue";
import ClockIcon from "@/components/icons/ClockLightGray.vue";
import INSERT_PROJECT_ACTIVITY_TIME from "@/apollo/projectActivities/InsertProjectActivityTime.gql";
import GET_PROJECT_ACTIVITY_TIMES from "@/apollo/projectActivities/GetProjectActivityTimes.gql";
import GET_PROJECT_ACTIVITY_REQUEST_MORE_HOURS from "@/apollo/projectActivities/GetRequstedHours.gql";
import FormGroup from "@/components/form/FormGroupNew.vue";
import DELETE_PROJECT_ACTIVITY_TIME from "@/apollo/projectActivities/DeleteProjectActivityTime.gql";
import DELETE_PROJECT_ACTIVITY_REQUEST_MORE_HOURS from "@/apollo/projectActivities/DeleteProjectActivityRequestedHours.gql";
import PROJECT_ACTIVITY_TIME_AGGREGATE from "@/apollo/projectActivities/ProjectActivityTimeAggregate.gql";
import PROJECT_ACTIVITY_REQUEST_MORE_HOURS_AGGREGATE from "@/apollo/projectActivities/ProjectActivityRequestMoreHoursAggregate.gql";
import {
  Project_Activity,
  Project_Activity_Time,
  Project_Activity_Request_More_Hours,
  User,
} from "@/generated/graphql";
import CrossIcon from "@/components/icons/CrossIconNew.vue";
import CrossIconHover from "@/components/icons/CrossIconHover.vue";
import convertSecondsToReadable from "@/utils/convertSecondsToReadable";
import NewTimePicker from "@/components/projects/timeTracker/NewTimePickerNew.vue";
import moment from "moment";

@Component({
  components: {
    UiButton,
    CrossIcon,
    CrossIconHover,
    TimeTrackingDelete,
    TimeTrackingEdit,
    ModalFullScreen,
    VueTimepicker,
    FormDatepicker,
    NewTimePicker,
    FormGroup,
    ClockIcon,
  },
  apollo: {
    trackedTimes: {
      query: GET_PROJECT_ACTIVITY_TIMES,
      variables() {
        return {
          activityId: this.activity?.id,
        };
      },
      update: (data) => data.project_activity_time,
    },
    timeAggregate: {
      query: PROJECT_ACTIVITY_TIME_AGGREGATE,
      variables() {
        return {
          activityId: this.activity?.id,
        };
      },
      update: (data) => data.project_activity_time_aggregate.aggregate.sum.time,
    },
    requestedHours: {
      query: GET_PROJECT_ACTIVITY_REQUEST_MORE_HOURS,
      variables() {
        return {
          activityId: this.activity?.id,
        };
      },
      update: (data) => data.project_activity_request_more_hours,
    },
    hoursAggregate: {
      query: PROJECT_ACTIVITY_REQUEST_MORE_HOURS_AGGREGATE,
      variables() {
        return {
          activityId: this.activity?.id,
        };
      },
      update: (data) =>
        data.project_activity_request_more_hours_aggregate.aggregate.sum.hours,
    },
  },
})
export default class TimeTrackerModal extends Vue {
  @Prop({ type: Object, required: true })
  readonly activity!: Project_Activity;
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
  @Prop({ type: String, required: true }) readonly tracked_date!: string;
  rangeTracker = false;
  timerTracker = true;
  manualTracker = false;
  isHovered: boolean = false;
  requestHoursSlot = false;
  activeClasses = "font-semibold activeClass";
  rangeTrackerClasses = "";
  timerTrackerClasses = "";
  manualTrackerClasses = "";
  requestHoursClasses = "";
  timeTrackedArray?: { status: String; date: String; time: String }[] = [
    { status: "approved", date: "02/02/2022", time: "12.23.23" },
    { status: "declined", date: "02/02/2022", time: "12.23.23" },
    { status: "pending", date: "02/02/2022", time: "12.23.23" },
    { status: "approved", date: "02/02/2022", time: "12.23.23" },
    { status: "declined", date: "02/02/2022", time: "12.23.23" },
    { status: "pending", date: "02/02/2022", time: "12.23.23" },
  ];
  start_time: string = "00:00:00";
  end_time: string = "00:00:01";
  notes: string = "";
  manualTimeInput: string = "00:00:00";
  trackedTimes: Project_Activity_Time[] = undefined;
  requestedHours: Project_Activity_Request_More_Hours[] = undefined;
  id: string = "";
  status: string = "CREATED";
  timeAggregate: number = 0;
  hoursAggregate: number = 0;
  timerRunning: boolean = false;
  timerStart: Date = localStorage.getItem("startTime")
    ? new Date(localStorage.getItem("startTime"))
    : new Date();
  timerStop: Date = localStorage.getItem("stopTime")
    ? new Date(localStorage.getItem("stopTime"))
    : new Date();
  timerRecorded: boolean = false;
  processing: boolean = false;
  currentUser: User = undefined;
  convertSecondsToReadable = convertSecondsToReadable;
  reason: string = "";
  requestTimeInput: string = "00:00:00";

  created(): void {
    this.currentUser = Vue.prototype.$currentUser;

    this.timerTrackerClasses = this.activeClasses;
  }

  isTimeAddedAlreadyStyle(requestHoursSlot, timeAggregate, hoursAggregate) {
    let result;
    if (
      requestHoursSlot
        ? convertSecondsToReadable(hoursAggregate) !== "00:00:00"
        : convertSecondsToReadable(timeAggregate) !== "00:00:00"
    ) {
      result = "w-auto xl:border-r-1 xl:border-gray-300 pr-4";
    } else {
      result = "w-full";
    }
    return result;
  }

  closeModal(): void {
    if (localStorage.getItem("timerInterval")) {
      var timerInterval = Number(localStorage.getItem("timerInterval"));
      window.clearInterval(timerInterval);
      localStorage.removeItem("timerInterval");
    }

    // window.location.reload();
    this.$emit("close");
  }

  resetPage(): void {
    this.start_time = "00:00:00";
    this.end_time = "00:00:01";
    this.notes = "";
    this.id = "";
    this.status = "CREATED";
    this.timerStart = new Date();
    this.timerStop = new Date();
    this.timerRunning = false;
    this.timerRecorded = false;
    this.processing = false;
    this.reason = "";
    this.refetchData();
  }

  showManualSlot(): void {
    this.resetPage();
    this.timerTracker = false;
    this.rangeTracker = false;
    this.requestHoursSlot = false;
    this.manualTracker = true;
    this.rangeTrackerClasses = "";
    this.timerTrackerClasses = "";
    this.requestHoursClasses = "";
    this.manualTrackerClasses = this.activeClasses;
  }

  get buttonText(): string {
    return "Save";
  }

  get buttonStartTimer(): String {
    if (this.timerRunning) {
      return "Stop Time";
    }
    return "Start Time";
  }

  get rangeTime(): number {
    if (!this.start_time || !this.end_time) {
      return 0;
    }
    var start_time = this.start_time
      .replace("HH", "00")
      .replace("mm", "00")
      .replace("ss", "00");
    var end_time = this.end_time
      .replace("HH", "00")
      .replace("mm", "00")
      .replace("ss", "00");
    var start = start_time.split(":");
    var end = end_time.split(":");
    var startDate = new Date(
      0,
      0,
      0,
      Number(start[0] ? start[0] : 0),
      Number(start[1] ? start[1] : 0),
      Number(start[2] ? start[2] : 0)
    );
    var endDate = new Date(
      0,
      0,
      0,
      Number(end[0] ? end[0] : 0),
      Number(end[1] ? end[1] : 0),
      Number(end[2] ? end[2] : 0)
    );
    var diff = endDate.getTime() - startDate.getTime();
    this.start_time = this.start_time
      .replace("HH", "00")
      .replace("mm", "00")
      .replace("ss", "00");
    this.end_time = this.end_time
      .replace("HH", "00")
      .replace("mm", "00")
      .replace("ss", "00");
    return diff / 1000;
  }

  get manualTime(): number {
    if (!this.manualTimeInput) {
      return 0;
    }
    var manualTimeInput = this.manualTimeInput
      .replace("HH", "00")
      .replace("mm", "00")
      .replace("ss", "00");
    var times = manualTimeInput.split(":");
    this.manualTimeInput = this.manualTimeInput
      .replace("HH", "00")
      .replace("mm", "00")
      .replace("ss", "00");
    return (
      Number(times[2]) + Number(times[1]) * 60 + Number(times[0]) * 60 * 60
    );
  }
  get requestHoursTime(): number {
    if (!this.requestTimeInput) {
      return 0;
    }
    var requestTimeInput = this.requestTimeInput
      .replace("HH", "00")
      .replace("mm", "00")
      .replace("ss", "00");
    var times = requestTimeInput.split(":");
    this.requestTimeInput = this.requestTimeInput
      .replace("HH", "00")
      .replace("mm", "00")
      .replace("ss", "00");
    return (
      Number(times[2]) + Number(times[1]) * 60 + Number(times[0]) * 60 * 60
    );
  }
  get timerTime(): number {
    if (!this.timerStart || !this.timerStop) {
      return 0;
    }
    var diff = this.timerStop.getTime() - this.timerStart.getTime();
    return diff / 1000;
  }

  async saveTimeTrack(): Promise<void> {
    this.processing = true;
    console.log("from button clicked", this.activity);
    var projectActivityTime = {
      activity_id: this.activity.id,
      contractor_id: this.activity.contractor_id,
      notes: this.notes,
      // time: this.timeSelect,
      start_time: this.start_time,
      end_time: this.end_time,
      tracked_date: moment(this.tracked_date).local().format("YYYY-MM-DD"),
      timesheet_id: (this.activity as any)?.timesheet_id,
    };

    await this.$apollo.mutate({
      mutation: INSERT_PROJECT_ACTIVITY_TIME,
      variables: {
        projectActivityTime: projectActivityTime,
      },
    });
    this.resetPage();
    this.$emit("close");
  }

  deleteTrackedTime(id: string): void {
    this.$confirm({
      title: `Delete tracked time for task ${this.activity?.title}`,
      message: `Are you sure?`,
      button: {
        no: "No",
        yes: "Yes",
      },
      callback: async (confirm: any) => {
        if (confirm) {
          await this.$apollo.mutate({
            mutation: DELETE_PROJECT_ACTIVITY_TIME,
            variables: {
              id: id,
            },
          });
          this.refetchData();
        }
      },
    });
  }
  deleteRequestedHours(id: string): void {
    this.$confirm({
      title: `Delete requested hours for task ${this.activity?.title}`,
      message: `Are you sure?`,
      button: {
        no: "No",
        yes: "Yes",
      },
      callback: async (confirm: any) => {
        if (confirm) {
          await this.$apollo.mutate({
            mutation: DELETE_PROJECT_ACTIVITY_REQUEST_MORE_HOURS,
            variables: {
              id: id,
            },
          });
          this.refetchData();
        }
      },
    });
  }

  refetchData(): void {
    this.$apollo.queries.trackedTimes.refetch();
    this.$apollo.queries.timeAggregate.refetch();
    this.$apollo.queries.requestedHours.refetch();
    this.$apollo.queries.hoursAggregate.refetch();
    this.$emit("timesChanged");
  }

  convertDateString(date: string): string {
    // date = date.replace("-", "/").replace("-", "/");
    var parts = date.split("-");
    // return date;
    return parts[2] + "/" + parts[1] + "/" + parts[0];
  }

  setToEdit(time: Project_Activity_Time): void {
    this.showManualSlot();
    this.id = time.id;
    this.notes = time.notes;
    // this.tracked_date = time.tracked_date;
    this.status = time.status;
    this.manualTimeInput = this.convertSecondsToReadable(time.time);
  }
  setToEditRequestedHours(time: Project_Activity_Request_More_Hours): void {
    // this.showRequestHoursSlot();
    this.id = time.id;
    this.reason = time.reason;
    this.status = time.status;
    this.requestTimeInput = this.convertSecondsToReadable(time.hours);
  }

  // async startStopTimer() {
  // 	let timedActivity = localStorage.getItem('activity')
  // 		? JSON.parse(localStorage.getItem('activity'))
  // 		: undefined;

  // 	const {isDisable, id: timesheetId} = await this.checkDateWeekDisable?.(this.tracked_date, this.activity)

  // 	if (isDisable) {
  // 		this.$eventBus.emit(
  // 			NOTIFICATION,
  // 			Message.errorMessage(
  // 				"The timesheet status must be open for the period: " + this.tracked_date.toString()
  // 			)
  // 		);
  // 		return;
  // 	}
  // 	if (
  // 		!timedActivity ||
  // 		(timedActivity && timedActivity.id === this.activity.id)
  // 	) {
  // 		if (!this.timerRunning) {
  // 			if (localStorage.getItem('timerInterval')) {
  // 				var timerInterval = Number(
  // 					localStorage.getItem('timerInterval')
  // 				);
  // 				window.clearInterval(timerInterval);
  // 			}
  // 			this.timerRunning = !this.timerRunning;
  // 			this.timerStart = new Date(
  // 				localStorage.getItem('startTime') || this.resetStartTime()
  // 			);
  // 			if (!localStorage.getItem('timerInterval')) {
  // 				this.displayTimer(timedActivity.timesheet_id || timedActivity.timesheetId || timesheetId);
  // 			}
  // 		} else {
  // 			if (localStorage.getItem('timerInterval')) {
  // 				var timerInterval = Number(
  // 					localStorage.getItem('timerInterval')
  // 				);
  // 				window.clearInterval(timerInterval);
  // 			}
  // 			this.timerRunning = !this.timerRunning;
  // 			this.timerStart = new Date(localStorage.getItem('startTime'));
  // 			this.timerStop = new Date();
  // 			this.$root.$emit('timerStopped');
  // 			localStorage.setItem('stopTime', this.timerStop.toString());
  // 			this.timerRecorded = true;
  // 			localStorage.setItem('timerRecorded', '1');
  // 			localStorage.setItem('timerRunning', '0');
  // 		}
  // 	} else {
  // 		alert(
  // 			"A timer is already running for task '" +
  // 				timedActivity?.title +
  // 				"'.\nPlease attend to that first."
  // 		);
  // 	}
  // }

  // displayTimer(timesheetId?:string): void {
  // 	var timerInterval = window.setInterval(() => {
  // 		if (document.getElementById('timerLabel')) {
  // 			document.getElementById('timerLabel').innerHTML =
  // 				this.getTimer();
  // 		}
  // 	}, 1000);
  // 	localStorage.setItem('timerInterval', timerInterval.toString());
  // 	if (!localStorage.getItem('activity')) {
  // 		if (timesheetId) {
  // 			localStorage.setItem('activity', JSON.stringify({...this.activity, timesheetId: timesheetId}));
  // 		}else {
  // 			localStorage.setItem('activity', JSON.stringify(this.activity));
  // 		}
  // 	}
  // 	if (!localStorage.getItem('tracked_date')) {
  // 		localStorage.setItem('tracked_date', this.tracked_date.toString());
  // 	}
  // 	if (!localStorage.getItem('timerOwner')) {
  // 		localStorage.setItem('timerOwner' + this.currentUser.id, '1');
  // 	}
  // 	this.$root.$emit('timerStarted');
  // }

  //   resetStartTime() {
  //     var startTime = new Date();
  //     localStorage.setItem("startTime", startTime.toString());
  //     localStorage.setItem("timerRecorded", "0");
  //     localStorage.setItem("timerRunning", "1");
  //     return startTime;
  //   }

  // discardTimer(): void {
  // 	this.timerStart = new Date();
  // 	this.timerStop = new Date();
  // 	this.timerRunning = false;
  // 	localStorage.removeItem('startTime');
  // 	localStorage.removeItem('stopTime');
  // 	localStorage.removeItem('timerRecorded');
  // 	localStorage.removeItem('timerRunning');
  // 	localStorage.removeItem('activity');
  // 	localStorage.removeItem('appTimer');
  // 	localStorage.removeItem('timerOwner' + this.currentUser.id);
  // 	if (document.getElementById('timerLabel')) {
  // 		document.getElementById('timerLabel').innerHTML = '00:00:00';
  // 	}
  // 	localStorage.removeItem('tracked_date');
  // 	this.timerRecorded = false;
  // 	this.$root.$emit('timerStopped');

  // 	if (localStorage.getItem('timerInterval')) {
  // 		var timerInterval = Number(localStorage.getItem('timerInterval'));
  // 		window.clearInterval(timerInterval);
  // 		localStorage.removeItem('timerInterval');
  // 	}
  // }

  getTimer(): string {
    var secsDiff = 0;
    if (!this.timerRunning && this.timerStart && this.timerStop) {
      secsDiff = this.timerStop.getTime() - this.timerStart.getTime();
      secsDiff = secsDiff / 1000;
    }
    if (this.timerStart && (!this.timerStop || this.timerRunning)) {
      secsDiff = new Date().getTime() - this.timerStart.getTime();
      secsDiff = secsDiff / 1000;
    }
    return this.convertSecondsToReadable(secsDiff);
  }

  // get showTrackingModes(): { title: string; project: string } {
  // 	let timedActivity = localStorage.getItem('activity')
  // 		? JSON.parse(localStorage.getItem('activity'))
  // 		: undefined;
  // 	if (
  // 		!timedActivity ||
  // 		(timedActivity && timedActivity.id === this.activity.id)
  // 	) {
  // 		return { title: '', project: '' };
  // 	}
  // 	return {
  // 		title: timedActivity.title,
  // 		project:
  // 			timedActivity.project && timedActivity.project.name
  // 				? timedActivity.project.name
  // 				: '',
  // 	};
  // }

  get end_timeHourRange(): Number[] {
    if (this.start_time) {
      let start_time = this.start_time
        .replace("HH", "00")
        .replace("mm", "00")
        .replace("ss", "00");
      let startParts = start_time.split(":");
      return [...Array(24 - Number(startParts[0])).keys()].flatMap(
        (i) => i + Number(startParts[0])
      );
    }
    return [...Array(24 - 0).keys()].flatMap((i) => i + 0);
  }

  get end_timeMinuteRange(): Number[] {
    if (
      this.start_time &&
      !(this.end_time.split(":")[0] > this.start_time.split(":")[0])
    ) {
      let start_time = this.start_time
        .replace("HH", "00")
        .replace("mm", "00")
        .replace("ss", "00");
      let startParts = start_time.split(":");
      return [...Array(60 - Number(startParts[1])).keys()].flatMap(
        (i) => i + Number(startParts[1])
      );
    }
    return [...Array(60 - 0).keys()].flatMap((i) => i + 0);
  }

  get end_timeSecondRange(): Number[] {
    if (
      this.start_time &&
      !(this.end_time.split(":")[0] > this.start_time.split(":")[0]) &&
      !(this.end_time.split(":")[1] > this.start_time.split(":")[1])
    ) {
      let start_time = this.start_time
        .replace("HH", "00")
        .replace("mm", "00")
        .replace("ss", "00");
      let startParts = start_time.split(":");
      return [...Array(60 - (Number(startParts[2]) + 1)).keys()].flatMap(
        (i) => i + (Number(startParts[2]) + 1)
      );
    }
    return [...Array(60 - 0).keys()].flatMap((i) => i + 0);
  }

  get end_timeError(): Boolean {
    if (this.start_time && this.end_time) {
      let start = this.start_time.split(":");
      let end = this.end_time.split(":");
      const sDate = new Date(
        0,
        0,
        0,
        Number(start[0]),
        Number(start[1]),
        Number(start[2])
      );
      const eDate = new Date(
        0,
        0,
        0,
        Number(end[0]),
        Number(end[1]),
        Number(end[2])
      );
      if (eDate > sDate) {
        return false;
      } else {
        return true;
      }
    }
    return false;
  }

  // async sendRequest(): Promise<void> {
  // 	this.processing = true;
  // 	if (!this.id) {
  // 		var projectActivityRequestedHours = {
  // 			hours: this.timeSelect,
  // 			reason: this.reason,
  // 			requester_id: this.currentUserId,
  // 			activity_id: this.activity.id,
  // 		};

  // 		await this.$apollo.mutate({
  // 			mutation: INSERT_PROJECT_ACTIVITY_MORE_HOURS_REQUEST,
  // 			variables: {
  // 				projectActivityRequestedHours:
  // 					projectActivityRequestedHours,
  // 			},
  // 		});
  // 	}

  // 	if (this.id) {
  // 		var obj = {
  // 			hours: this.timeSelect,
  // 			status: this.status,
  // 			reason: this.reason,
  // 		};
  // 		await this.$apollo.mutate({
  // 			mutation: UPDATE_PROJECT_ACTIVITY_REQUEST_MORE_HOURS,
  // 			variables: {
  // 				id: this.id,
  // 				obj: obj,
  // 			},
  // 		});
  // 	}
  // 	this.resetPage();
  // }

  // savedTimeToManualInput(): void {
  //   // diff is the saved time
  //   var hours = Math.floor(diff / 1000 / 60 / 60);
  //   diff -= hours * 1000 * 60 * 60;
  //   var minutes = Math.floor(diff / 1000 / 60);
  //   diff -= minutes * 1000 * 60;
  //   var seconds = Math.floor(diff / 1000);

  //   // If using time pickers with 24 hours format, add the below line get exact hours
  //   if (hours < 0) {
  //      hours = hours + 24;
  //   }
  // }
}
